import { QueryHookOptions, useMutation, useQuery } from '@apollo/client';
import {
  DOWNLOAD_CSV,
  DOWNLOAD_CSV_JOB_FOR_MEDIA_OFFLINE,
  DOWNLOAD_CSV_JOB_FOR_MEDIA_ONLINE,
  DOWNLOAD_SUMMARY_ONLINE_MEDIA,
  DOWNLOAD_SUMMARY_REPORT
} from './graphql/download/mutation';
import {
  DownloadSummaryReportResponse,
  DownloadSummaryReportPayload,
  GetSummaryReportListPayload,
  GetSummaryReportListResponse,
  TExportType
} from 'src/models/download';
import { GET_SUMMARY_REPORT_STATUS_LIST } from './graphql/download/query';

const useDownload = () => {
  const [downloadCsv, resDownloadCsv] = useMutation<
    any,
    { exportType?: TExportType }
  >(DOWNLOAD_CSV);

  const [downloadCsvMediaOnline, resDownloadCsvMediaOnline] = useMutation<
    any,
    {
      exportType?: TExportType;
    }
  >(DOWNLOAD_CSV_JOB_FOR_MEDIA_ONLINE);

  const [downloadMediaOffline, resDownloadCsvMediaOffline] = useMutation<
    any,
    {
      exportType?: TExportType;
      offlineMediaType: 'print' | 'broadcast';
    }
  >(DOWNLOAD_CSV_JOB_FOR_MEDIA_OFFLINE);

  const [downloadSummaryOnlineMedia, resDownloadSummaryOnlineMedia] =
    useMutation(DOWNLOAD_SUMMARY_ONLINE_MEDIA);

  const [downloadSummaryReport, resDownloadSummaryReport] = useMutation<
    DownloadSummaryReportResponse,
    DownloadSummaryReportPayload
  >(DOWNLOAD_SUMMARY_REPORT, {
    refetchQueries: [GET_SUMMARY_REPORT_STATUS_LIST]
  });

  const useGetSummaryReportList = (
    options: QueryHookOptions<
      GetSummaryReportListResponse,
      GetSummaryReportListPayload
    >
  ) => {
    return useQuery<GetSummaryReportListResponse, GetSummaryReportListPayload>(
      GET_SUMMARY_REPORT_STATUS_LIST,
      options
    );
  };

  return {
    downloadCsv,
    resDownloadCsv,
    downloadCsvMediaOnline,
    resDownloadCsvMediaOnline,
    downloadSummaryOnlineMedia,
    resDownloadSummaryOnlineMedia,
    downloadSummaryReport,
    resDownloadSummaryReport,
    useGetSummaryReportList,
    downloadCsvMediaOffline: downloadMediaOffline,
    resDownloadCsvMediaOffline
  };
};

export default useDownload;
